import Rails from '@rails/ujs';

export default class BackofficeApiLogsIndex {
  constructor() {
    this.tableSelector = '#api-logs-datatable';
    this.modalBodySelector = '#api-log-modal-body';

    this.initDataTable();
    this.bindModalLoad();
  }

  initDataTable() {
    const $table = $(this.tableSelector);
    if ($table.length === 0) {
      return;
    }

    const ajaxUrl = $table.data('ajax-url');
    if (!ajaxUrl) {
      return;
    }

    $table.DataTable({
      serverSide: true,
      processing: true,
      searching: true,
      responsive: true,
      order: [[2, 'desc']],
      ajax: {
        url: ajaxUrl,
        type: 'GET'
      },
      columns: [
        { data: 'action' },
        { data: 'status' },
        { data: 'created_at' },
        { data: 'actions' }
      ],
      columnDefs: [
        {
          targets: 3,
          orderable: false
        }
      ]
    });
  }

  bindModalLoad() {
    $(document).on('click', '.js-api-log-show', (event) => {
      const $button = $(event.currentTarget);
      const url = $button.data('url');

      if (!url) {
        return;
      }

      $(this.modalBodySelector).html('<div class="text-center text-muted">Chargement...</div>');

      fetch(url, {
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': Rails.csrfToken()
        }
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Request failed');
          }
          return response.json();
        })
        .then((payload) => {
          $(this.modalBodySelector).html(payload.html || '');
        })
        .catch(() => {
          $(this.modalBodySelector).html('<div class="text-danger">Erreur lors du chargement du log.</div>');
        });
    });
  }
}
